import axios from 'axios';
import { globalState } from '@/globalState';

export const baseApi = axios.create({
  baseURL: 'api/'
});
baseApi.interceptors.response.use(res => {
  return res;
}, err => {
  if (err.config.url != 'api/auth/info' && err.response.status === 401) {
    globalState.isLoggedIn = false;
  }

  return Promise.reject(err);
});